module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_18_3.7327f95f.jpeg";